<template>
  <div>
    <v-expansion-panels flat class="flat-expanssion-panel" v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text d-flex align-center justify-content-between">
          <v-tooltip color="white" v-if="contentJson?.lang?.[language]?.text || contentJson?.text" right content-class="tooltip-box-content" max-width="360" :open-delay="300" :close-delay="200" transition="slide-x-transition">
            <template v-slot:activator="{on, attrs}">
              <div v-bind="attrs" v-on="on" style="margin-right: -40px">
                {{ $t("basic-data-parcel") }}
                <span v-if="hasAtLeastOneWarning" style="color: red; font-size: 15px">&#9888;</span>
              </div>
            </template>
            <div v-html="contentJson?.lang?.[language]?.text || contentJson?.text"></div>
          </v-tooltip>
          <div v-else style="margin-right: 26px">
            {{ $t("basic-data-parcel") }}
            <span v-if="hasAtLeastOneWarning" style="color: red; font-size: 15px">&#9888;</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <TooltipTR section="section100" field="PRC_ID" :label="$t('parcel-id')">
                  <div>{{ $t("parcel-id") }}</div>
                  <div>{{ plotItem.PRC_ID }}</div>
                </TooltipTR>
                <TooltipTR section="section100" field="PRC_NO" :label="$t('parcel-no')">
                  <div>
                    <b>{{ $t("parcel-no") }}</b>
                  </div>
                  <div>
                    <b>{{ plotItem.PRC_NO }}</b>
                  </div>
                </TooltipTR>
                <TooltipTR section="section100" field="PRC_SUR" :label="$t('size')">
                  <div>
                    <b>{{ $t("size") }}</b>
                  </div>
                  <div>
                    <b>{{ plotItem.PRC_SUR }} </b> m²
                  </div>
                </TooltipTR>
                <TooltipTR section="section100" field="PRC_TYP" :label="$t('property-type')">
                  <div>
                    {{ $t("property-type") }}
                    <span v-if="plotItem.PRC_TYP_LABEL == 'Y'" style="color: red; font-size: 20px; line-height: 1">&#9888;</span>
                  </div>
                  <div>
                    {{ plotItem.PRC_TYP }}
                  </div>
                </TooltipTR>
                <TooltipTR section="section100" field="PRC_COO" :label="$t('coordinates-center')">
                  <div>{{ $t("coordinates-center") }}</div>
                  <div>{{ plotItem.PRC_COO_X }} - {{ plotItem.PRC_COO_Y }}</div>
                </TooltipTR>
                <TooltipTR section="section100" field="PRC_COU" :label="$t('country')">
                  <div>{{ $t("country") }}</div>
                  <div>{{ plotItem.PRC_COU }}</div>
                </TooltipTR>
                <TooltipTR section="section100" field="CANTON" :label="$t('canton-state')">
                  <div>{{ $t("canton-state") }}</div>
                  <div>{{ plotItem.CANTON }}</div>
                </TooltipTR>
                <TooltipTR section="section100" field="LOCNAME" :label="$t('municipality')">
                  <div>{{ $t("municipality") }}</div>
                  <div>
                    {{ plotItem.LOCNAME }} <small class="grey--text">({{ plotItem.PRC_MUN_CAT }})</small>
                  </div>
                </TooltipTR>
                <TooltipTR section="section100" field="PRC_ZIP" :label="$t('postal-code')">
                  <div>{{ $t("postal-code") }}</div>
                  <div>{{ plotItem.PRC_ZIP }}</div>
                </TooltipTR>
                <TooltipTR section="section100" field="STREET_ADDRESS" :label="$t('street')">
                  <div>{{ $t("street") }}</div>
                  <div>
                    <ul class="list-plot-lists" v-if="isStreetArray">
                      <li v-for="(item, index) in plotItem.STREET_ADDRESSES" :key="index">{{ item }}</li>
                    </ul>
                    <span v-else>
                      <ul class="list-plot-lists">
                        <li>{{ plotItem.STREET_ADDRESS }}</li>
                      </ul>
                    </span>
                  </div>
                </TooltipTR>
                <TooltipTR section="section100" field="PRC_PLA" :label="$t('prc_pla')">
                  <div>{{ $t("prc_pla") }}</div>
                  <div>{{ plotItem.PRC_PLA }}</div>
                </TooltipTR>
                <TooltipTR section="section100" field="KANTON" :label="$t('kanton')">
                  <div>{{ $t("kanton") }}</div>
                  <div>{{ plotItem.KANTON }}</div>
                </TooltipTR>
                <TooltipTR section="section100" field="PRC_SLO" :label="$t('prc_slo')">
                  <div>
                    {{ $t("prc_slo") }}
                    <span v-if="plotItem.PRC_SLO_LABEL == 'Y'" style="color: red; font-size: 20px; line-height: 1">&#9888;</span>
                  </div>
                  <div>
                    {{ plotItem.PRC_SLO }}
                    <span v-if="plotItem.PRC_SLO != null">{{ plotItem.PRC_SLO_UNIT }}</span>
                  </div>
                </TooltipTR>
                <TooltipTR section="section100" field="PRC_SLO_PER" :label="$t('prc_slo_per')">
                  <div>
                    {{ $t("prc_slo_per") }}
                    <span v-if="plotItem.PRC_SLO_PER_LABEL == 'Y'" style="color: red; font-size: 20px; line-height: 1">&#9888;</span>
                  </div>
                  <div>
                    {{ plotItem.PRC_SLO_PER }}
                    <span v-if="plotItem.PRC_SLO_PER != null">{{ plotItem.PRC_SLO_PER_UNIT }}</span>
                  </div>
                </TooltipTR>
                <TooltipTR section="section100" field="PRC_ASP" :label="$t('prc_asp')">
                  <div>{{ $t("prc_asp") }}</div>
                  <div>{{ plotItem.PRC_ASP }}</div>
                </TooltipTR>
                <TooltipTR section="section100" field="PRC_BUILD_AREA" :label="$t('prc_build_area')">
                  <div>{{ $t("prc_build_area") }}</div>
                  <div>{{ plotItem.PRC_BUILD_AREA }}</div>
                </TooltipTR>
                <TooltipTR section="section100" field="PRC_BUILD" :label="$t('prc_build')">
                  <div>{{ $t("prc_build") }}</div>
                  <div>{{ plotItem.PRC_BUILD }}</div>
                </TooltipTR>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator"
import TooltipTR from "./TooltipText.vue"

@Component({
  components: {TooltipTR},
})
export default class ViewPlotDetails100 extends Vue {
  @Prop()
  plotItem

  showPopup = false

  panel = 0

  get hasAtLeastOneWarning() {
    if (this.plotItem.PRC_TYP_LABEL == "Y") {
      return true
    }
    return false
  }

  get isStreetArray() {
    return Array.isArray(this.plotItem.STREET_ADDRESSES)
  }

  contentJson: any = {}
  language

  created() {
    this.language = localStorage.getItem("user-language") || "en"
    this.loadTooltip()
  }

  async loadTooltip() {
    this.contentJson = (await this.$store.dispatch("tooltip/getTooltipContent", "section100")) || {}
  }
}
</script>
